import "./AbTestStyles.css";
import AbTestStep2Image from "./AbTestStep2Image";
import AbTestStep2Text from "./AbTestStep2Text";

const AbTestStep2 = ({ setActiveTab, selectedTest, setSelectedTest }) => {
  if (!selectedTest || !selectedTest?.element?.data) {
    return (
      <h3>
        Invalid selection. Please{" "}
        <span onClick={() => setActiveTab(1)} className="fc-blue underline-4">
          select another element
        </span>
      </h3>
    );
  }

  if (selectedTest.element.tag === "img") {
    return (
      <div>
        <AbTestStep2Image
          selectedTest={selectedTest}
          setSelectedTest={setSelectedTest}
          setActiveTab={setActiveTab}
        />
      </div>
    );
  }

  return (
    <AbTestStep2Text
      setActiveTab={setActiveTab}
      selectedTest={selectedTest}
      setSelectedTest={setSelectedTest}
    />
  );
};

export default AbTestStep2;
